import { ClaimFormSubmitFieldValue } from '../types/claim-form-submit-field-value';

// @TODO
//   - Put this list in some dedicated place
//     so new components know to put their type here
export const getClaimFormSubmitValue = (
    component:
        | 'file'
        | 'radiobuttons'
        | 'checkboxes'
        | 'numberfield'
        | 'currencyfield'
        | 'datepicker'
        | 'textarea'
        | 'textfield'
        | 'amountOrUnknown'
        | 'yearfield'
        | 'cprfield'
        | 'cvrfield'
        | 'dropdown'
        | 'contact-email'
        | 'contact-phone'
        | 'contact-email-update-profile'
        | 'contact-phone-update-profile'
        | 'addressradioselection'
        | 'addressfield'
        | 'phoneField'
        | 'customervehicle'
        | 'consent'
        | 'vehiclezone'
        | 'timeintervals'
        | 'carbrands'
        | 'countries'
        | 'supmanwidget'
        | 'supmanwidgetcombined'
        | 'scalepointwidget'
        | 'animal'
        | 'teeth'
        | 'animalsicknessexistingclaimswidget'
        | 'emailField'
        | 'automaticConsent'
        | 'examination'
        | 'previousxxamination'
        | 'groupoftextfields'
        | 'licenseplatefield'
        | 'policedistricts',
    name: string,
    label: string,
    value: string,
    valueID: any
): ClaimFormSubmitFieldValue => {
    return { name, label, component, value, valueID };
};
